
<div *ngIf="announcement && !dismissed"
     class="announcement-banner alert alert-dismissible fade show mb-0 rounded-0"
     [ngClass]="getPriorityClass()"
     role="alert">
  <div class="container-fluid">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center flex-grow-1">
        <i class="fas {{ getPriorityIcon() }} fa-lg me-3"></i>
        <div>
          <strong class="me-2">Announcement:</strong>
          <span>{{ announcement.message }}</span>
          <!--<span class="badge bg-light text-dark ms-2" *ngIf="announcement.priority !== 'normal'">
            {{ announcement.priority | titlecase }} Priority
          </span>-->
        </div>
      </div>
      <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
    </div>
  </div>
</div>
